import React from "react";
import PropTypes from "prop-types";
import Avatar from "./Avatar";

const DefaultLayout = (props) => {
  const { links } = props;
  console.debug("Default navigation");
  return (
    <React.Fragment>
      <div className="branding">
        <div className="branding-logo">
          <p>
            <img src={props.imagePath} alt="" />
          </p>
        </div>
        <div className="login-detail">
          <Avatar />
        </div>
      </div>
      <div className="head">
        <div className="navigation navigation-primary">
          <ul>
            {links
              .sort((a, b) => a.index - b.index)
              .map((link, idx) => (
                <li
                  className={
                    link.link.split("/")[1] ===
                    window.location.pathname.split("/")[1]
                      ? "active"
                      : ""
                  }
                  key={`${link.index}_${idx}`}
                >
                  <a
                    href={link.link}
                    className={`button button-icon button-${link.classOverride}`}
                  >
                    {link.title}
                    <span></span>
                  </a>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

DefaultLayout.propTypes = {
  links: PropTypes.array,
  imagePath: PropTypes.string,
};
export default DefaultLayout;
